<template>
  <div class="w-full h-full overflow-y-auto">
    <div class="md:py-20 flex items-center justify-center w-full py-6">
      <div class="card relative w-full max-w-lg shadow-xl">
        <div class="prose">
          <slot name="header" />
          <h2>
            How did we calculate your carbon footprint ?
          </h2>

          <p>
            It all start with the country where you live and, then, it is influenced by your life and consumption habits.
          </p>

          <ul>
            <li>Country (35%)</li>
            <li>Commute (19%)</li>
            <li>Diet (20%)</li>
            <li>Home energy (19%)</li>
            <li>Shopping (7%)</li>
            <li>Flights (0.09 ton of CO2 per hour)</li>
          </ul>

          <p>
            This result represents the standard allocation of what drives your footprint, but depending on your answers the allocation may defer.
          </p>

          <slot name="action" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "v-explanation",
};
</script>
